import type { ReactElement } from 'react';

/** 一覧の上下に置くページネーション（指示書 §7-1）。 */
export function Pagination({
  page,
  perPage,
  total,
  onChange,
  label,
}: {
  page: number;
  perPage: number;
  total: number;
  onChange: (page: number) => void;
  label?: string;
}): ReactElement {
  const lastPage = Math.max(1, Math.ceil(total / perPage));

  return (
    <nav
      aria-label={label ?? 'ページ送り'}
      className="flex items-center justify-end gap-2 px-3 py-2.5 text-wptext-muted"
    >
      <span>{total}件</span>
      <button
        type="button"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
        aria-label="前のページ"
        className="btn-secondary px-2 py-0.5"
      >
        ‹
      </button>
      <span aria-live="polite">
        {page} / {lastPage}
      </span>
      <button
        type="button"
        onClick={() => onChange(page + 1)}
        disabled={page >= lastPage}
        aria-label="次のページ"
        className="btn-secondary px-2 py-0.5"
      >
        ›
      </button>
    </nav>
  );
}
